<template>
    <h2>
      <span class="mname">{{ month.name }}</span> {{ month.year }}
    </h2>
    <div class="weekdays">
      <div v-for="dayOfWeek in daysOfWeek" 
        :key="dayOfWeek"
        class="weekday">
          {{ dayOfWeek }}
      </div>
    </div>
    <template v-for="week in weeks">
      <div class="days" :class="{'active' : week.selected}">
        <div v-for="day in week.days"
          @click="dayChoosed(day)"
          :key="day.key"
          :class="day.classes">
          {{ day.text }}
        </div>
      </div>
    </template>
</template>

<script>
export default {
  name:"MonthItem",
  props:["month","daysOfWeek","days","selectedWeek"],
  emits:["clickedDay"],
  data(){
    return {
      today: new Date(),
      date: new Date(`${this.month.month}/01/${this.month.year}`),
      startOfWeek: null
    }
  },
  computed: {
    weeks() {
      const weeks = [];
      let week = [];
      this.days.forEach((day, index) => {
        week.push(day);
        if (week.length === 7 || index === this.days.length - 1) {
          let ndate = new Date(this.month.year,this.month.month-1,day.text);
          const weekNumber = this.getWeekNumber(ndate);
//        const weekNumber = this.getWeekNumber(new Date(`${this.month.month}/${day.text}/${this.month.year}`));
          weeks.push({days: week, selected: this.isDaySelected(weekNumber)});
          week = [];
        }
      });
      const lastWeek = weeks[weeks.length - 1];
      if (lastWeek.length < 7) {
        const numEmptyCells = 7 - lastWeek.length;
        for (let i = 0; i < numEmptyCells; i++) {
          lastWeek.push({ key: i, text: '', classes: 'day empty' });
        }
      }
      return weeks;
    }
  },
  methods:{
    isDaySelected(weekNumber){
      return weekNumber === this.selectedWeek?.weekNumber &&
             this.month.year === this.selectedWeek.year;
    },
    getWeekNumber(date) {
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay()||7));
      var yearStart = new Date(Date.UTC(date.getUTCFullYear(),0,1));
      var weekNo = Math.ceil(( ( (date - yearStart) / 86400000) + 1)/7);
      return weekNo;
    },
    dayChoosed(day){
      const date = new Date(`${this.month.month}/${day.text}/${this.month.year}`);
      var weekNo = this.getWeekNumber(date);
      this.$emit("clickedDay",{month: this.month, day: day, weekNumber: weekNo})
    }
  }
};
</script>

<style lang="scss" scoped>

.month {
  margin-bottom: 16px;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.weekday {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  font-size: 16px;
  color: #999;
  font-weight: 600;
}

@media screen and (max-width:767px) {
  .weekday {
    font-size: 13px;
    color: #aaa8a8;
    font-family: "Montserrat Bold";
  }
}

h2{
  font-size: 16px;
  font-family: "Montserrat";
}

.mname{
  padding-left: 15px;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  border: 1px dashed transparent;
}

.day {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  font-size: 14px;
  color: rgb(176, 175, 175);
  font-weight: 600;
  cursor: pointer;
  font-family: "Montserrat Light";
}

.day.today{
  background-color: #2650e7;
  color: white;
}

.empty {
  background-color: transparent;
  color: #ccc;
}

.days:hover,.days.active{
  border: 1px dashed #2650e7;
}


</style>
